import { render, staticRenderFns } from "./RevenueSplitSummary.vue?vue&type=template&id=29f367b4&scoped=true"
import script from "./RevenueSplitSummary.vue?vue&type=script&lang=js"
export * from "./RevenueSplitSummary.vue?vue&type=script&lang=js"
import style0 from "./RevenueSplitSummary.vue?vue&type=style&index=0&id=29f367b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f367b4",
  null
  
)

export default component.exports